module.exports = __webpack_public_path__ + "static/img/logo.d1aaccf8.svg";